/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React, { useRef, useEffect, useState } from "react";

import { SessionErrorDialog } from "../elements/session-error-modal";
import ConfirmationDialog from "../elements/confirmation-dialog/ConfirmationDialog";
import { StyledFooter } from "./styled-footer";
import FooterReassurance from "./Reassurance";
import FooterLinks from "./FooterLinks";
import FooterContact from "./FContact";
import FooterMention from "./FooterMention";
import FooterLogos from "./FLogos";
import FooterNav from "./FooterNav";

function Footer(props: any) {
  const footerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setIsVisible(true);
          setShouldRender(true);
          // Once footer is loaded, we can disconnect the observer
          observer.disconnect();
        }
      },
      {
        // Trigger when footer is about to enter viewport
        rootMargin: "100px 0px 0px 0px", // Load 100px before it becomes visible
        threshold: 0.1, // Trigger when 10% of the footer is visible
      }
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <div ref={footerRef} style={{ minHeight: "200px" }}>
        {shouldRender ? (
          <StyledFooter>
            <FooterReassurance />
            <FooterContact />
            <FooterLinks />
            <FooterMention />
            <FooterLogos />
            <FooterNav />
          </StyledFooter>
        ) : (
          // Placeholder to maintain layout and trigger intersection
          <div style={{ height: "200px", background: "transparent" }} />
        )}
      </div>
      <SessionErrorDialog />
      <ConfirmationDialog />
    </>
  );
}

export default React.memo(Footer);
